const ENV = {
  LCL: {
    REACT_APP_API_SERVER: 'https://stg-user-api.atwill-net.com',
    SCORING_DOMAIN: 'https://stg-edu-auto-marking-web.bappartners.com/',
    ORACLE_DOMAIN: 'https://objectstorage.ap-tokyo-1.oraclecloud.com/n/sanarucloud/b/stg-edu-pdf-tool/o/',
    SCHOOL_ID_NO_2: '1075',
    SCHOOL_ID_NO_1: '1075',
    USER_ID_NO_2: [
      '0915004',
      '20000952',
      '22004861',
      '23003497',
      '20010905',
      '22014233',
      '22014232',
      '21010729',
      '23004980',
      '21001875',
      '22013830'
    ],
    USER_ID_NO_1: [
      '0915004',
      '20000952',
      '22004861',
      '23003497',
      '20010905',
      '22014233',
      '22014232',
      '21010729',
      '23004980',
      '21001875',
      '22013830',
      '00001016',
      '00001017',
      '00001018',
      '00001019',
      '00001020',
      '00001045',
      '00001046',
      '00001047'
    ],
    SCHOOL_BUILDING_CODE_NO_2: [
      '1006',
      '1018',
      '1104',
      '1110',
      '1201',
      '1202',
      '1303',
      '2201',
      '2000',
      '2001',
      '2002',
      '2103',
      '2104',
      '2207',
      '3100',
      '4470',
      '4480',
      '2310',
      '2311',
      '2412',
      '2413',
      '2414',
      '2515',
      '2516',
      '2517',
      '2519',
      '2520',
      '2521',
      '2522',
      '2523',
      '2524',
      '2525',
      '2526',
      '2527',
      '2601',
      '2602',
      '2617',
      '3200',
      '3300',
      '4500',
      '4501',
      '8888'
    ],
    SCHOOL_BUILDING_CODE_NO_1: []
  },

  DEV: {
    REACT_APP_API_SERVER: 'https://dev-edu-gakutore-api.bappartners.com',
    SCORING_DOMAIN: 'https://dev-edu-auto-marking-web.bappartners.com/',
    ORACLE_DOMAIN: 'https://objectstorage.ap-tokyo-1.oraclecloud.com/n/nrzfrynccg3o/b/edu-pdf-tool-dev/o/'
  },

  STG: {
    REACT_APP_API_SERVER: 'https://stg-user-api.atwill-net.com',
    SCORING_DOMAIN: 'https://stg-edu-auto-marking-web.bappartners.com/',
    ORACLE_DOMAIN: 'https://objectstorage.ap-tokyo-1.oraclecloud.com/n/sanarucloud/b/stg-edu-pdf-tool/o/',
    SCHOOL_ID_NO_2: '1075',
    SCHOOL_ID_NO_1: '1075',
    USER_ID_NO_2: [
      '0915004',
      '20000952',
      '22004861',
      '00000011',
      '00000012',
      '00000013',
      '00000110',
      '00001011',
      '00001012',
      '00001013',
      '00001014',
      '00001015',
      '00001016',
      '00001017',
      '00001018',
      '00001019',
      '00001020',
      '00001021',
      '00001022',
      '00001023',
      '00001024',
      '00001025',
      '00001026',
      '00001027',
      '00001028',
      '00001031',
      '00001033',
      '00001034',
      '00001035',
      '00001036',
      '00001037',
      '00001038',
      '00001039',
      '00001040',
      '00001041',
      '00001042',
      '00001043',
      '00001044',
      '00001045',
      '00001046',
      '00001047',
      '00001048',
      '00001049',
      '00001050',
      '00001051',
      '00001052',
      '00001053',
      '00001054',
      '00001055',
      '00001056',
      '00001057',
      '00001059',
      '00001061',
      '00001062',
      '00001063',
      '00001067',
      '00001068',
      '00001069',
      '00001088',
      '00001089',
      '00001099',
      '00001101',
      '00001103',
      '00001120',
      '00001149',
      '21001441',
      '18016102',
      '21010847',
      '16021826',
      '21010473',
      '21010846',
      '23003497',
      '20010905',
      '22014233',
      '22014232',
      '21010729',
      '23004980',
      '21001875',
      '22013830'
    ],
    USER_ID_NO_1: [
      '0915004',
      '20000952',
      '22004861',
      '21001441',
      '18016102',
      '21010847',
      '16021826',
      '21010473',
      '21010846',
      '23003497',
      '20010905',
      '22014233',
      '22014232',
      '21010729',
      '23004980',
      '21001875',
      '22013830',
      '00001016',
      '00001017',
      '00001018',
      '00001019',
      '00001020',
      '00001045',
      '00001046',
      '00001047'
    ],
    SCHOOL_BUILDING_CODE_NO_2: [
      '1006',
      '1018',
      '1104',
      '1110',
      '1201',
      '1202',
      '1303',
      '2201',
      '2000',
      '2001',
      '2002',
      '2103',
      '2104',
      '2207',
      '3100',
      '4470',
      '4480',
      '2310',
      '2311',
      '2412',
      '2413',
      '2414',
      '2515',
      '2516',
      '2517',
      '2519',
      '2520',
      '2521',
      '2522',
      '2523',
      '2524',
      '2525',
      '2526',
      '2527',
      '2601',
      '2602',
      '2617',
      '3200',
      '3300',
      '4500',
      '4501',
      '8888'
    ],
    SCHOOL_BUILDING_CODE_NO_1: [
      '1374',
      '1572'
    ]
  },

  PRO: {
    REACT_APP_API_SERVER: 'https://ai-api.atwill-net.com',
    SCORING_DOMAIN: 'https://ai-scan.atwill-net.com/',
    ORACLE_DOMAIN: 'https://objectstorage.ap-tokyo-1.oraclecloud.com/n/sanarucloud/b/ai_gakutore/o/',
    SCHOOL_ID_NO_2: '7001',
    SCHOOL_ID_NO_1: '7001',
    USER_ID_NO_2: [
      '0003',
      '0010',
      '0004',
      '00000011',
      '00000012',
      '00000013',
      '00000110',
      '00001011',
      '00001012',
      '00001013',
      '00001014',
      '00001015',
      '00001016',
      '00001017',
      '00001018',
      '00001019',
      '00001020',
      '00001021',
      '00001022',
      '00001023',
      '00001024',
      '00001025',
      '00001026',
      '00001027',
      '00001028',
      '00001031',
      '00001033',
      '00001034',
      '00001035',
      '00001036',
      '00001037',
      '00001038',
      '00001039',
      '00001040',
      '00001041',
      '00001042',
      '00001043',
      '00001044',
      '00001045',
      '00001046',
      '00001047',
      '00001048',
      '00001049',
      '00001050',
      '00001051',
      '00001052',
      '00001053',
      '00001054',
      '00001055',
      '00001056',
      '00001057',
      '00001059',
      '00001061',
      '00001062',
      '00001063',
      '00001067',
      '00001068',
      '00001069',
      '00001088',
      '00001089',
      '00001099',
      '00001101',
      '00001103',
      '00001120',
      '00001149'
    ],
    USER_ID_NO_1: [
      '0003',
      '0010',
      '0004',
      '00000105',
      '00001016',
      '00001017',
      '00001018',
      '00001019',
      '00001020',
      '00001045',
      '00001046',
      '00001047'
    ],
    SCHOOL_BUILDING_CODE_NO_2: [
      '1006',
      '1018',
      '1104',
      '1110',
      '1201',
      '1202',
      '1303',
      '1023',
      '1096',
      '1097',
      '1808',
      '9017',
      '1307',
      '1014',
      '1006',
      '1008',
      '1010',
      '1013',
      '1015',
      '1016',
      '1020',
      '1021',
      '1025',
      '1031',
      '1032',
      '1033',
      '1035',
      '1036',
      '1102',
      '1573',
      '1491',
      '1103',
      '1104',
      '1105',
      '1107',
      '1108',
      '1109',
      '1112',
      '1201',
      '1202',
      '1095',
      '1160',
      '1203',
      '1204',
      '1205',
      '1303',
      '9021',
      '9033',
      '9034',
      '2397',
      '2103',
      '2205',
      '2526',
      '1009',
      '1173',
      '1271',
      '1022',
      '1110',
      '2544',
      '2545',
      '2172',
      '1091',
      '1092',
      '1191',
      '1691',
      '1291',
      '1391',
      '1392',
      '1791',
      '2091',
      '2291',
      '1060',
      '1061',
      '1062',
      '1063',
      '2550',
      '2173',
      '2101',
      '2011',
      '2013',
      '2025',
      '2026',
      '2708',
      '1017',
      '1066',
      '2112',
      '2305',
      '2503',
      '2534',
      '2703',
      '2319',
      '1881',
      '1891',
      '2012',
      '1106',
      '2547',
      '1002',
      '1004',
      '1306',
      '1401',
      '1407',
      '1502',
      '1701',
      '1702',
      '1704',
      '1705',
      '1706',
      '1707',
      '1802',
      '1803',
      '2001',
      '2002',
      '2003',
      '2005',
      '2006',
      '2008',
      '2009',
      '2010',
      '1094',
      '8810',
      '2597',
      '2548',
      '2549',
      '2194',
      '8801',
      '8802',
      '8803',
      '8804',
      '8808',
      '2594',
      '8806',
      '8807',
      '8809',
      '2595',
      '1086',
      '2599',
      '1494',
      '2207',
      '2598',
      '2570',
      '2712',
      '2392',
      '2713',
      '1592',
      '2553',
      '2571',
      '1892',
      '2102',
      '2304',
      '2313',
      '1071',
      '1072',
      '1792',
      '1192',
      '2791',
      '2203',
      '1012',
      '1806',
      '2563',
      '2566',
      '2567',
      '2564',
      '2568',
      '2312',
      '2315',
      '2316',
      '2317',
      '2318',
      '2501',
      '2505',
      '2507',
      '2509',
      '2511',
      '2513',
      '2515',
      '2518',
      '2520',
      '2094',
      '2308',
      '1087',
      '2521',
      '2104',
      '2105',
      '2107',
      '2110',
      '2111',
      '2201',
      '2202',
      '2204',
      '2206',
      '2211',
      '2301',
      '2302',
      '2306',
      '2307',
      '2310',
      '9002',
      '2592',
      '2396',
      '2092',
      '2710',
      '2593',
      '2792',
      '2543',
      '2303',
      '1005',
      '2311',
      '2004',
      '2106',
      '2551',
      '2519',
      '1011',
      '1304',
      '2522',
      '2542',
      '1065',
      '2261',
      '2561',
      '9042',
      '9063',
      '9064',
      '2196',
      '2072',
      '8401',
      '2398',
      '1193',
      '9059',
      '9074',
      '9075',
      '1088',
      '9048',
      '2295',
      '9066',
      '2366',
      '2683',
      '2562',
      '2541',
      '2523',
      '2524',
      '2525',
      '2193',
      '2527',
      '2528',
      '2529',
      '2530',
      '2531',
      '2532',
      '2533',
      '2535',
      '2536',
      '2537',
      '2538',
      '2314',
      '2391',
      '1807',
      '1074',
      '1505',
      '2393',
      '2195',
      '1076',
      '1075',
      '1073',
      '1371',
      '1372',
      '1373',
      '1374',
      '1771',
      '2171',
      '2192',
      '2546',
      '2539',
      '2591',
      '2701',
      '2702',
      '2704',
      '2705',
      '2706',
      '2399',
      '2007',
      '1408',
      '1471',
      '1572',
      '2271',
      '1693',
      '2361',
      '1067',
      '1081',
      '1082',
      '2552',
      '1393',
      '1394',
      '8805',
      '2596',
      '2097',
      '9062',
      '2365',
      '2096',
      '2095',
      '2573',
      '2554',
      '2273',
      '2772',
      '2294',
      '1098',
      '2692',
      '9060',
      '9067',
      '9069',
      '2071',
      '9061',
      '2771',
      '2073',
      '9068',
      '2364',
      '8887',
      '8888',
      '8889',
      '2074',
      '8402',
      '2309',
      '2482',
      '2575',
      '2576',
      '2774',
      '1174',
      '2555',
      '2556',
      '1078',
      '2014',
      '2795',
      '9046',
      '1793',
      '1079',
      '2272',
      '1772',
      '9070',
      '1018',
      '9030',
      '2174',
      '9025',
      '9029',
      '2689',
      '1893',
      '9035',
      '2362',
      '2363',
      '9043',
      '2572',
      '2574',
      '2773',
      '2075',
      '2578',
      '2579',
      '2320',
      '1872',
      '2699',
      '8890',
      '1495',
      '2661',
      '2662',
      '2061',
      '2062',
      '2342',
      '2343',
      '2344',
      '2622',
      '2623',
      '2624',
      '2625',
      '2626',
      '2628',
      '2629',
      '2630',
      '2631',
      '2632',
      '2633',
      '2634',
      '2635',
      '2761',
      '2621',
      '2341',
      '2627',
      '1068',
      '1873',
      '1194',
      '2161',
      '2181',
      '2367',
      '2557',
      '1093',
      '8812',
      '2796',
      '4001',
      '4002',
      '4003',
      '4004',
      '4005',
      '4006',
      '4007',
      '4008',
      '4009',
      '4010',
      '4101',
      '4104',
      '4105'
    ],
    SCHOOL_BUILDING_CODE_NO_1: [
      '1023',
      '1096',
      '1097',
      '1808',
      '9017',
      '1307',
      '1014',
      '1006',
      '1008',
      '1010',
      '1013',
      '1015',
      '1016',
      '1020',
      '1021',
      '1025',
      '1031',
      '1032',
      '1033',
      '1035',
      '1036',
      '1102',
      '1573',
      '1491',
      '1103',
      '1104',
      '1105',
      '1107',
      '1108',
      '1109',
      '1112',
      '1201',
      '1202',
      '1095',
      '1160',
      '1203',
      '1204',
      '1205',
      '1303',
      '9021',
      '9033',
      '9034',
      '2397',
      '2103',
      '2205',
      '2526',
      '1009',
      '1173',
      '1271',
      '1022',
      '1110',
      '2544',
      '2545',
      '2172',
      '1091',
      '1092',
      '1191',
      '1691',
      '1291',
      '1391',
      '1392',
      '1791',
      '2091',
      '2291',
      '1060',
      '1061',
      '1062',
      '1063',
      '2550',
      '2173',
      '2101',
      '2011',
      '2013',
      '2025',
      '2026',
      '2708',
      '1017',
      '1066',
      '2112',
      '2305',
      '2503',
      '2534',
      '2703',
      '2319',
      '1881',
      '1891',
      '2012',
      '1106',
      '2547',
      '1002',
      '1004',
      '1306',
      '1401',
      '1407',
      '1502',
      '1701',
      '1702',
      '1704',
      '1705',
      '1706',
      '1707',
      '1802',
      '1803',
      '2001',
      '2002',
      '2003',
      '2005',
      '2006',
      '2008',
      '2009',
      '2010',
      '1094',
      '8810',
      '2597',
      '2548',
      '2549',
      '2194',
      '8801',
      '8802',
      '8803',
      '8804',
      '8808',
      '2594',
      '8806',
      '8807',
      '8809',
      '2595',
      '1086',
      '2599',
      '1494',
      '2207',
      '2598',
      '2570',
      '2712',
      '2392',
      '2713',
      '1592',
      '2553',
      '2571',
      '1892',
      '2102',
      '2304',
      '2313',
      '1071',
      '1072',
      '1792',
      '1192',
      '2791',
      '2203',
      '1012',
      '1806',
      '2563',
      '2566',
      '2567',
      '2564',
      '2568',
      '2312',
      '2315',
      '2316',
      '2317',
      '2318',
      '2501',
      '2505',
      '2507',
      '2509',
      '2511',
      '2513',
      '2515',
      '2518',
      '2520',
      '2094',
      '2308',
      '1087',
      '2521',
      '2104',
      '2105',
      '2107',
      '2110',
      '2111',
      '2201',
      '2202',
      '2204',
      '2206',
      '2211',
      '2301',
      '2302',
      '2306',
      '2307',
      '2310',
      '9002',
      '2592',
      '2396',
      '2092',
      '2710',
      '2593',
      '2792',
      '2543',
      '2303',
      '1005',
      '2311',
      '2004',
      '2106',
      '2551',
      '2519',
      '1011',
      '1304',
      '2522',
      '2542',
      '1065',
      '2261',
      '2561',
      '9042',
      '9063',
      '9064',
      '2196',
      '2072',
      '8401',
      '2398',
      '1193',
      '9059',
      '9074',
      '9075',
      '1088',
      '9048',
      '2295',
      '9066',
      '2366',
      '2683',
      '2562',
      '2541',
      '2523',
      '2524',
      '2525',
      '2193',
      '2527',
      '2528',
      '2529',
      '2530',
      '2531',
      '2532',
      '2533',
      '2535',
      '2536',
      '2537',
      '2538',
      '2314',
      '2391',
      '1807',
      '1074',
      '1505',
      '2393',
      '2195',
      '1076',
      '1075',
      '1073',
      '1371',
      '1372',
      '1373',
      '1374',
      '1771',
      '2171',
      '2192',
      '2546',
      '2539',
      '2591',
      '2701',
      '2702',
      '2704',
      '2705',
      '2706',
      '2399',
      '2007',
      '1408',
      '1471',
      '1572',
      '2271',
      '1693',
      '2361',
      '1067',
      '1081',
      '1082',
      '2552',
      '1393',
      '1394',
      '8805',
      '2596',
      '2097',
      '9062',
      '2365',
      '2096',
      '2095',
      '2573',
      '2554',
      '2273',
      '2772',
      '2294',
      '1098',
      '2692',
      '9060',
      '9067',
      '9069',
      '2071',
      '9061',
      '2771',
      '2073',
      '9068',
      '2364',
      '8887',
      '8888',
      '8889',
      '2074',
      '8402',
      '2309',
      '2482',
      '2575',
      '2576',
      '2774',
      '1174',
      '2555',
      '2556',
      '1078',
      '2014',
      '2795',
      '9046',
      '1793',
      '1079',
      '2272',
      '1772',
      '9070',
      '1018',
      '9030',
      '2174',
      '9025',
      '9029',
      '2689',
      '1893',
      '9035',
      '2362',
      '2363',
      '9043',
      '2572',
      '2574',
      '2773',
      '2075',
      '2578',
      '2579',
      '2320',
      '1872',
      '2699',
      '8890',
      '1495',
      '2661',
      '2662',
      '2061',
      '2062',
      '2342',
      '2343',
      '2344',
      '2622',
      '2623',
      '2624',
      '2625',
      '2626',
      '2628',
      '2629',
      '2630',
      '2631',
      '2632',
      '2633',
      '2634',
      '2635',
      '2761',
      '2621',
      '2341',
      '2627',
      '1068',
      '1873',
      '1194',
      '2161',
      '2181',
      '2367',
      '2557',
      '1093',
      '8812',
      '2796',
      '4001',
      '4002',
      '4003',
      '4004',
      '4005',
      '4006',
      '4007',
      '4008',
      '4009',
      '4010',
      '4101',
      '4104',
      '4105'
    ]
  }
};

const config = ENV[process.env.REACT_APP_STAGE || 'LCL'];

const getEnv = (name, defaultValue) =>
  process.env[name] || config[name] || defaultValue;

export { getEnv };
